(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9684],{

/***/ 26308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(26208);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/contact.service.ts
var contact_service = __webpack_require__(20644);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Background",
  componentId: "sc-y2oqks-0"
})(["background:", ";margin-bottom:", ";"], function (props) {
  return props.withoutBackground ? props.theme.colors.white : props.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(240));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Wrapper",
  componentId: "sc-y2oqks-1"
})(["padding:", ";margin-top:", ";display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(20));
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Form",
  componentId: "sc-y2oqks-2"
})(["background:", ";padding:", ";border-radius:", ";margin-bottom:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(-200));
var FormFieldsStyles = (0,styled_components_browser_esm/* css */.iv)(["width:100%;padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";display:block;&.error{margin-bottom:0;border-color:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(700));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ContactFormelements__Input",
  componentId: "sc-y2oqks-3"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(50));
var TextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "ContactFormelements__TextArea",
  componentId: "sc-y2oqks-4"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(150));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__ErrorMessage",
  componentId: "sc-y2oqks-5"
})(["margin:", " 0 ", " 0;display:block;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.danger;
});
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__GlobalErrorMessage",
  componentId: "sc-y2oqks-6"
})(["color:", ";padding-top:", ";margin-bottom:-", ";display:block;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10));
var Agreement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Agreement",
  componentId: "sc-y2oqks-7"
})(["margin:", " 0;"], (0,polished_esm/* rem */.hO)(35));
var AgreementLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ContactFormelements__AgreementLink",
  componentId: "sc-y2oqks-8"
})(["color:", ";text-decoration:unset;cursor:pointer;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__SuccessMessage",
  componentId: "sc-y2oqks-9"
})(["color:", ";padding-top:", ";display:block;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ContactFormTemplate = function ContactFormTemplate(_ref) {
  var withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var nameInputRef = (0,react.useRef)();
  var emailInputRef = (0,react.useRef)();
  var phoneInputRef = (0,react.useRef)();
  var messageInputRef = (0,react.useRef)();

  var _useGoogleReCaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)(),
      executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;

  var _useState = (0,react.useState)(false),
      hasAgreement = _useState[0],
      setHasAgreement = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasNameError = _useState2[0],
      setHasNameError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasEmailError = _useState3[0],
      setHasEmailError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      hasMessageError = _useState4[0],
      setMessageError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      hasSentError = _useState5[0],
      setHasSentError = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isSent = _useState7[0],
      setIsSent = _useState7[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _nameInputRef$current, _emailInputRef$curren, _emailInputRef$curren2, _messageInputRef$curr;

      var hasError, _nameInputRef$current2, _nameInputRef$current3, _emailInputRef$curren3, _phoneInputRef$curren, _phoneInputRef$curren2, _messageInputRef$curr2, generatedToken, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasNameError(false);
              setHasEmailError(false);
              setMessageError(false);
              setHasSentError(false);
              setIsSent(false);
              hasError = false;

              if (!((nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current = nameInputRef.current) === null || _nameInputRef$current === void 0 ? void 0 : _nameInputRef$current.value) === '')) {
                _context.next = 9;
                break;
              }

              setHasNameError(true);
              return _context.abrupt("return");

            case 9:
              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context.next = 12;
                break;
              }

              setHasEmailError(true);
              return _context.abrupt("return");

            case 12:
              if (!((messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr = messageInputRef.current) === null || _messageInputRef$curr === void 0 ? void 0 : _messageInputRef$curr.value) === '')) {
                _context.next = 15;
                break;
              }

              setMessageError(true);
              return _context.abrupt("return");

            case 15:
              if (!hasError) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              _context.prev = 17;
              setIsLoading(true);
              _context.next = 21;
              return executeRecaptcha();

            case 21:
              generatedToken = _context.sent;
              data = _objectSpread(_objectSpread(_objectSpread({}, (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) && {
                name: nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value
              }), {}, {
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value
              }, (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) && {
                phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value
              }), {}, {
                message: messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr2 = messageInputRef.current) === null || _messageInputRef$curr2 === void 0 ? void 0 : _messageInputRef$curr2.value,
                token: generatedToken
              });
              _context.next = 25;
              return contact_service/* contactApi.contact */.e.contact(data);

            case 25:
              setIsSent(true);
              setIsLoading(false);
              emailInputRef.current.value = '';
              nameInputRef.current.value = '';
              phoneInputRef.current.value = '';
              messageInputRef.current.value = '';
              _context.next = 36;
              break;

            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](17);
              setHasSentError(true);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 33]]);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    withoutBackground: withoutBackground,
    children: [hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
            tagType: Title/* TitleTagTypes.H3 */.Z.H3,
            isBlack: true,
            children: t('contact.contact.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: nameInputRef,
            placeholder: t('contact.form.name.placeholder'),
            className: "".concat(hasNameError ? 'error' : '')
          }), hasNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.name.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: emailInputRef,
            placeholder: t('contact.form.email.placeholder'),
            className: "".concat(hasEmailError ? 'error' : '')
          }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.email.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: phoneInputRef,
            placeholder: t('contact.form.phone.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
            ref: messageInputRef,
            placeholder: t('contact.form.message.placeholder'),
            className: "".concat(hasMessageError ? 'error' : '')
          }), hasMessageError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.message.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Agreement, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Checkbox/* default */.Z, {
              name: "agreement",
              onChange: function onChange() {
                return setHasAgreement(!hasAgreement);
              },
              checked: hasAgreement,
              children: ["S\xFAhlas\xEDm s", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(AgreementLink, {
                href: "https://www.zakon.sk/ochrana-osobnych-udajov.xhtml",
                children: "podmienkami spracovania osobn\xFDch \xFAdajov"
              })]
            })
          }), (hasNameError || hasEmailError || hasMessageError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
            children: t('contact.form.error')
          }), !isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: isLoading,
            disabled: !hasAgreement,
            marginTop: 25,
            onClick: handleClick,
            text: "Odosla\u0165"
          }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: t('contact.form.sent')
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ContactForm = (ContactFormTemplate);

/***/ }),

/***/ 91149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Faqs; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Faqs/Faqs.elements.tsx




var Transportation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__Transportation",
  componentId: "sc-7m7y6v-0"
})(["display:flex;flex-direction:column;margin:", " 0;padding:", ";@media (min-width:", "px){flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(10));
var TransportationOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationOptions",
  componentId: "sc-7m7y6v-1"
})(["width:100%;padding:", " 0;@media (min-width:", "px){width:65%;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md);
var TransportationOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationOption",
  componentId: "sc-7m7y6v-2"
})([""]);
var TransportationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationHeader",
  componentId: "sc-7m7y6v-3"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:", " 0;border-bottom:1px solid ", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
});
var TransportationHeaderTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Faqselements__TransportationHeaderTitle",
  componentId: "sc-7m7y6v-4"
})(["font-size:", ";&.isOpen{color:", ";}"], (0,polished_esm/* rem */.hO)(18), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var TransportationHeaderIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "Faqselements__TransportationHeaderIcon",
  componentId: "sc-7m7y6v-5"
})(["svg{width:", ";height:", ";}&.isOpen{svg{transform:rotate(180deg);}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var TransportationDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationDescription",
  componentId: "sc-7m7y6v-6"
})(["padding:", " 0;line-height:", ";.withBorder{text-decoration:underline;display:block;padding:", " 0;}.question{text-decoration:underline;}li{margin:", " 0;}a{color:", ";text-decoration:underline;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Faqs/Faqs.tsx











var ABOUT_QUESTIONS = [{
  id: 1,
  question: 'about.faq.question1.title',
  answer: 'about.faq.question1.answer.question1'
}, {
  id: 2,
  question: 'about.faq.question2.title',
  answer: 'about.faq.question2.answer.question1'
}, {
  id: 3,
  question: 'about.faq.question3.title',
  answer: 'about.faq.question3.answer.question1'
}, {
  id: 4,
  question: 'about.faq.question4.title',
  answer: 'about.faq.question4.answer.question1'
}, {
  id: 5,
  question: 'about.faq.question5.title',
  answer: 'about.faq.question5.answer.question1'
}, {
  id: 6,
  question: 'about.faq.question6.title',
  answer: 'about.faq.question6.answer.question1'
}];
var SUBSCRIPTION_QUESTIONS = [{
  id: 1,
  question: 'subscription.question1.question',
  answer: 'subscription.question1.answer'
}, {
  id: 2,
  question: 'subscription.question2.question',
  answer: 'subscription.question2.answer'
}, {
  id: 3,
  question: 'subscription.question3.question',
  answer: 'subscription.question3.answer'
}, {
  id: 4,
  question: 'subscription.question4.question',
  answer: 'subscription.question4.answer'
}, {
  id: 5,
  question: 'subscription.question5.question',
  answer: 'subscription.question5.answer'
}, {
  id: 6,
  question: 'subscription.question6.question',
  answer: 'subscription.question6.answer'
}, {
  id: 7,
  question: 'subscription.question7.question',
  answer: 'subscription.question7.answer'
}, {
  id: 8,
  question: 'subscription.question8.question',
  answer: 'subscription.question8.answer'
}, {
  id: 9,
  question: 'subscription.question9.question',
  answer: 'subscription.question9.answer'
}, {
  id: 10,
  question: 'subscription.question10.question',
  answer: 'subscription.question10.answer'
}];
var DEFAULT_OPENED_KEY = 'ako-prebieha-online-skolenie';

var FaqsTemplate = function FaqsTemplate() {
  var _ABOUT_QUESTIONS$;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(router.asPath.includes(DEFAULT_OPENED_KEY) ? [(_ABOUT_QUESTIONS$ = ABOUT_QUESTIONS[0]) === null || _ABOUT_QUESTIONS$ === void 0 ? void 0 : _ABOUT_QUESTIONS$.id] : []),
      openedAreas = _useState[0],
      setOpenedAreas = _useState[1];

  (0,useScrollToSection/* default */.Z)(DEFAULT_OPENED_KEY, DEFAULT_OPENED_KEY, 250);

  var toggleTransportationOption = function toggleTransportationOption(option) {
    if (openedAreas.includes(option)) {
      setOpenedAreas([]);
    } else {
      setOpenedAreas([]);
      setTimeout(function () {
        window.scrollTo({
          top: document.getElementById("".concat(option)).offsetTop - 150,
          behavior: 'smooth'
        });
        setOpenedAreas([option]);
      }, 50);
    }
  };

  (0,useScrollToSection/* default */.Z)('faqs', 'faqsId');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    mobileSidePadding: 20,
    id: "faqsId",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Transportation, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        alignLeft: true,
        isBlack: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: t(router.pathname.includes(constants/* ROUTES.SUBSCRIPTION */.Z6.SUBSCRIPTION) ? 'subscription.faq.title' : 'about.faq.title')
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationOptions, {
        children: (router.pathname.includes(constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US) ? ABOUT_QUESTIONS : SUBSCRIPTION_QUESTIONS).map(function (area, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
              id: "".concat(area.id),
              onClick: function onClick() {
                return toggleTransportationOption(area.id);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
                className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                children: t(area.question)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
                className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
              })]
            }), openedAreas.includes(area.id) && /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationDescription, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: t(area.answer)
                }
              })
            })]
          }, key);
        })
      })]
    })
  });
};

/* harmony default export */ var Faqs = (FaqsTemplate);

/***/ }),

/***/ 31828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* binding */ SUBSCRIPTION_PACKAGES_KEYS; },
/* harmony export */   "QG": function() { return /* binding */ SUBSCRIPTION_PACKAGES; }
/* harmony export */ });
/* unused harmony export SUBSCRIPTION_PACKAGES_KEYS_ENUM */
var SUBSCRIPTION_PACKAGES = [{
  title: 'Dane a účtovníctvo',
  key: 'taxes',
  moduleId: 'taxes',
  color: '#F2941A',
  saleBoxBackground: '#FAEFE1',
  redirectLink: '/skolenia?rocne_predplatne=taxes',
  icon: 'D',
  benefits: ['<span class="bold">100+ online školení</span> naživo <br /><a href="/skolenia?rocne_predplatne=taxes">Zobraziť najbližšie školenia</a>', 'Jedno predplatné <br /><span class="bold">pre 5 osôb (4 ZDARMA)</span>', '<span class="bold">Odborné konzultácie</span> <br /> s lektormi cez chat', '<span class="bold">Videozáznamy</span> <br /> a školiace materiály', '<span class="bold">10 % zľava</span> na konferencie <br /> a prezenčné školenia'],
  price: '527,67',
  priceWithoutVat: '429',
  eso9: 'SRPVDAUEPI000'
}, {
  title: 'Mzdy a personalistika',
  key: 'wages',
  moduleId: 'wages',
  color: '#F00035',
  saleBoxBackground: '#F7DADA',
  redirectLink: '/skolenia?rocne_predplatne=wages',
  icon: 'M',
  benefits: ['<span class="bold">100+ online školení</span> naživo <br /><a href="/skolenia?rocne_predplatne=wages">Zobraziť najbližšie školenia</a>', 'Jedno predplatné <br /><span class="bold">pre 5 osôb (4 ZDARMA)</span>', '<span class="bold">Odborné konzultácie</span> <br /> s lektormi cez chat', '<span class="bold">Videozáznamy</span> <br /> a školiace materiály', '<span class="bold">10 % zľava</span> na konferencie <br /> a prezenčné školenia'],
  price: '527,67',
  priceWithoutVat: '429',
  eso9: 'SRPVMAPEPI000'
}, {
  title: 'Verejná správa',
  key: 'government',
  moduleId: 'government',
  color: '#63BF4D',
  saleBoxBackground: '#E7F5E4',
  redirectLink: '/skolenia?rocne_predplatne=government',
  icon: 'V',
  benefits: ['<span class="bold">150+ online školení</span> naživo <br /><a href="/skolenia?rocne_predplatne=government">Zobraziť najbližšie školenia</a>', 'Jedno predplatné <br /><span class="bold">pre 5 osôb (4 ZDARMA)</span>', '<span class="bold">Odborné konzultácie</span> <br /> s lektormi cez chat', '<span class="bold">Videozáznamy</span> <br /> a školiace materiály', '<span class="bold">10 % zľava</span> na konferencie <br /> a prezenčné školenia'],
  garantLogo: 'zmos.png',
  price: '527,67',
  priceWithoutVat: '429',
  eso9: 'SRPVVSEPI000'
}];
var SUBSCRIPTION_PACKAGES_KEYS = ['taxes', 'wages', 'government'];
var SUBSCRIPTION_PACKAGES_KEYS_ENUM = {
  TAXES: 'taxes',
  WAGES: 'wages',
  GOVERNMENT: 'government'
};

/***/ }),

/***/ 36797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ rocne_predplatne; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Archive/Archive.tsx + 1 modules
var Archive = __webpack_require__(99361);
// EXTERNAL MODULE: ./src/components/ContactForm/ContactForm.tsx + 1 modules
var ContactForm = __webpack_require__(26308);
// EXTERNAL MODULE: ./src/components/Exhibitors/Exhibitors.tsx + 1 modules
var Exhibitors = __webpack_require__(67450);
// EXTERNAL MODULE: ./src/components/Faqs/Faqs.tsx + 1 modules
var Faqs = __webpack_require__(91149);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useCart.tsx + 1 modules
var useCart = __webpack_require__(44722);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/ui/Package/Package.tsx + 1 modules
var Package = __webpack_require__(42420);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/packages.ts
var constants_packages = __webpack_require__(31828);
// EXTERNAL MODULE: ./src/hooks/useGTM.ts
var useGTM = __webpack_require__(56643);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/SubscriptionPackages/Packages.elements.tsx




var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__Background",
  componentId: "sc-1p1uqnz-0"
})([""]);
var Packages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__Packages",
  componentId: "sc-1p1uqnz-1"
})(["display:flex;flex-wrap:wrap;justify-content:center;margin-top:", ";padding-bottom:", ";@media (min-width:", "px){margin-top:", ";}@media (min-width:", "px){justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(60), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.lg */.A.lg);
var Packages_elements_Package = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__Package",
  componentId: "sc-1p1uqnz-2"
})(["display:flex;flex-direction:column;padding:0 ", ";width:100%;margin:", " ", " 0 ", ";position:relative;border:1px solid ", ";border-radius:", ";position:relative;@media (min-width:", "px){max-width:", ";}@media (min-width:", "px){max-width:31%;margin:1%;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(120), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(12), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(460), theme/* breakpoints.md */.A.md);
var PackageImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Packageselements__PackageImage",
  componentId: "sc-1p1uqnz-3"
})(["width:", ";margin:-", " auto 0 10%;"], (0,polished_esm/* rem */.hO)(200), (0,polished_esm/* rem */.hO)(100));
var GarantSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__GarantSection",
  componentId: "sc-1p1uqnz-4"
})(["position:absolute;right:", ";top:", ";display:flex;flex-direction:column;align-items:center;"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10));
var GarantImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Packageselements__GarantImage",
  componentId: "sc-1p1uqnz-5"
})(["width:", ";"], (0,polished_esm/* rem */.hO)(65));
var GarantLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Packageselements__GarantLabel",
  componentId: "sc-1p1uqnz-6"
})(["font-size:", ";margin-top:", ";color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(8), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grey;
});
var PackageLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Packageselements__PackageLabel",
  componentId: "sc-1p1uqnz-7"
})(["display:block;margin-top:", ";font-size:", ";padding-left:", ";"], (0,polished_esm/* rem */.hO)(4), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(50));
var PackageTitle = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Packageselements__PackageTitle",
  componentId: "sc-1p1uqnz-8"
})(["font-weight:", ";display:flex;align-items:center;gap:", ";margin:", " 0 ", " 0;font-size:", ";&:hover,&:focus-visible{color:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h5;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});
var PackagePriceSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageselements__PackagePriceSection",
  componentId: "sc-1p1uqnz-9"
})(["text-align:center;"]);
var PackagePrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Packageselements__PackagePrice",
  componentId: "sc-1p1uqnz-10"
})(["font-weight:", ";font-size:1rem;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeights.textBold;
});
var PackagePriceWithoutVat = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Packageselements__PackagePriceWithoutVat",
  componentId: "sc-1p1uqnz-11"
})(["display:block;padding-top:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(10), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.h6;
});
var PackageDescriptionList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Packageselements__PackageDescriptionList",
  componentId: "sc-1p1uqnz-12"
})(["padding:", " 0 ", " ", ";"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5));
var PackageDescriptionItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Packageselements__PackageDescriptionItem",
  componentId: "sc-1p1uqnz-13"
})(["margin-bottom:", ";color:", ";font-size:", ";line-height:", ";list-style:none;display:flex;svg{width:", ";height:", ";margin-right:", ";margin-top:", ";g polyline{stroke:", ";}}a{color:", ";font-size:", ";}.bold{font-weight:", ";color:", ";}"], (0,polished_esm/* rem */.hO)(15), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.secondaryGrey;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(28), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(2), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.black;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontSizes.textMedium;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeights.textBold;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.black;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SubscriptionPackages/Packages.tsx


















var PackagesTemplate = function PackagesTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(false),
      loadingCart = _useState[0],
      setLoadingCart = _useState[1];

  var _useState2 = (0,react.useState)(null),
      selectedProduct = _useState2[0],
      setSelectedProduct = _useState2[1];

  var _useCart = (0,useCart/* default */.ZP)(),
      addOrUpdateItemInCart = _useCart.addOrUpdateItemInCart;

  var _useGTM = (0,useGTM/* useGTM */.l)(),
      viewItem = _useGTM.viewItem;

  (0,react.useEffect)(function () {
    if (constants_packages/* SUBSCRIPTION_PACKAGES */.QG) {
      constants_packages/* SUBSCRIPTION_PACKAGES */.QG === null || constants_packages/* SUBSCRIPTION_PACKAGES */.QG === void 0 ? void 0 : constants_packages/* SUBSCRIPTION_PACKAGES.forEach */.QG.forEach(function (item) {
        var data = {
          value: item === null || item === void 0 ? void 0 : item.price.replace(/,/g, '.'),
          currency: 'EUR',
          items: [{
            item_id: item === null || item === void 0 ? void 0 : item.eso9,
            item_name: item === null || item === void 0 ? void 0 : item.title,
            item_brand: 'Profivzdelávanie',
            price: item === null || item === void 0 ? void 0 : item.price.replace(/,/g, '.'),
            quantity: 1
          }]
        };
        viewItem(data);
      });
    }
  }, [constants_packages/* SUBSCRIPTION_PACKAGES */.QG]);

  var handleAddToCart = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(moduleId, key) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoadingCart(true);
              setSelectedProduct(key);
              _context.next = 5;
              return addOrUpdateItemInCart(moduleId, 1);

            case 5:
              setLoadingCart(false);
              setSelectedProduct(null);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setLoadingCart(false);
              setSelectedProduct(null);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function handleAddToCart(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Background, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('packages.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Packages, {
        children: constants_packages/* SUBSCRIPTION_PACKAGES.map */.QG.map(function (subscriptionPackage, subscriptionPackageKey) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Packages_elements_Package, {
            children: [(subscriptionPackage === null || subscriptionPackage === void 0 ? void 0 : subscriptionPackage.garantLogo) && /*#__PURE__*/(0,jsx_runtime.jsxs)(GarantSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GarantImage, {
                src: (0,url_utils/* publicAssets */.VK)("/".concat(subscriptionPackage.garantLogo))
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(GarantLabel, {
                children: "Odborn\xFD garant"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageImage, {
              src: (0,url_utils/* publicAssets */.VK)("/".concat(subscriptionPackage.key, ".png"))
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PackageTitle, {
              href: subscriptionPackage === null || subscriptionPackage === void 0 ? void 0 : subscriptionPackage.redirectLink,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Package/* default */.Z, {
                symbol: subscriptionPackage.icon,
                color: subscriptionPackage.color
              }), ' ', subscriptionPackage.title]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageLabel, {
              children: t('packages.label1')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageLabel, {
              children: t('packages.label2')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageDescriptionList, {
              children: subscriptionPackage.benefits.map(function (benefit, benefitKey) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(PackageDescriptionItem, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                    name: Icon/* Icons.CheckThin */.PJ.CheckThin
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                      __html: benefit
                    }
                  })]
                }, benefitKey);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackagePriceSection, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PackagePrice, {
                children: [subscriptionPackage.priceWithoutVat, " \u20AC bez DPH / rok"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackagePriceSection, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PackagePriceWithoutVat, {
                children: [subscriptionPackage.price, " \u20AC s DPH / rok"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              marginTop: 20,
              marginBottom: 20,
              text: t('packages.package.button'),
              isLoading: loadingCart && selectedProduct == subscriptionPackage.key,
              disabled: loadingCart && selectedProduct == subscriptionPackage.key,
              onClick: function onClick() {
                return handleAddToCart(subscriptionPackage.moduleId, subscriptionPackage.key);
              }
            })]
          }, subscriptionPackageKey);
        })
      })]
    })
  });
};

/* harmony default export */ var SubscriptionPackages_Packages = (PackagesTemplate);
;// CONCATENATED MODULE: ./src/components/SubscriptionVideo/Video.elements.tsx



var Video_elements_Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Videoelements__Background",
  componentId: "sc-10djek4-0"
})(["background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkLight;
});
var Video = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Videoelements__Video",
  componentId: "sc-10djek4-1"
})([""]);
var Player = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
  displayName: "Videoelements__Player",
  componentId: "sc-10djek4-2"
})(["width:100%;border-radius:", ";@media (min-width:", "px){width:80%;margin:0 10%;}"], (0,polished_esm/* rem */.hO)(14), theme/* breakpoints.sm */.A.sm);
;// CONCATENATED MODULE: ./src/components/SubscriptionVideo/Video.tsx








var VideoTemplate = function VideoTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Video_elements_Background, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      withPadding: true,
      mobileSidePadding: 20,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('subscription.video.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Video, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Player, {
          controls: true,
          playsInline: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            src: "https://tv.epi.sk/__pp/_pv/video-pv-2024-lq.mp4",
            type: "video/mp4"
          })
        })
      })]
    })
  });
};

/* harmony default export */ var SubscriptionVideo_Video = (VideoTemplate);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/pages/rocne-predplatne.tsx



















var ClassroomRent = function ClassroomRent(_ref) {
  var videos = _ref.videos,
      videosCount = _ref.videosCount;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.subscription.title'),
      description: t('seo.subscription.description'),
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK,
      openGraph: {
        images: [{
          url: "https://profivzdelavanie.sk".concat((0,url_utils/* publicAssets */.VK)('/og-konferencia.png'))
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "subscription.hero.title",
      imageKey: "subscription_hero.webp",
      listKeys: ['subscription.hero.paragraph1', 'subscription.hero.paragraph2', 'subscription.hero.paragraph3', 'subscription.hero.paragraph4']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriptionPackages_Packages, {}), videosCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Archive/* default */.Z, {
        videos: videos,
        count: videosCount
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriptionVideo_Video, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var rocne_predplatne = (ClassroomRent);

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ contactApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var CONTACT = 'pv/contact';
var WITHDRAWAL = 'pv/contact/withdrawal';
var COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';
var contactApi = {
  contact: function contact(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(CONTACT, data);
  },
  withdrawal: function withdrawal(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(WITHDRAWAL, data);
  },
  companyCoursesOrder: function companyCoursesOrder(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(COMPANY_COURSES_ORDER, data);
  }
};

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-1"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-2"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-3"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (props) {
  return props.withoutBottomPadding ? 0 : (0,polished_esm/* rem */.hO)(30);
}, theme/* breakpoints.md */.A.md, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-4"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Benefit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefit",
  componentId: "sc-1nsgps3-6"
})(["display:flex;flex-direction:column;align-items:center;flex-wrap:wrap;width:50%;margin-bottom:", ";@media (min-width:", "px){width:25%;margin-bottom:0;}@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.lg */.A.lg);
var Benefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefits",
  componentId: "sc-1nsgps3-7"
})(["display:flex;justify-content:space-between;padding:0 0 ", " 0;flex-wrap:wrap;margin-top:", ";max-width:", ";margin:", " auto ", " auto;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(-40), (0,polished_esm/* rem */.hO)(40));
var BenefitNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitNumber",
  componentId: "sc-1nsgps3-8"
})(["font-size:", ";font-family:", ";font-weight:700;color:", ";padding-right:", ";white-space:nowrap;"], (0,polished_esm/* rem */.hO)(48), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontSecondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(15));
var BenefitLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitLabel",
  componentId: "sc-1nsgps3-9"
})(["font-weight:", ";font-size:", ";text-align:center;line-height:", ";@media (min-width:", "px){text-align:left;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeights.textBold;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx










var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      listKeys = _ref.listKeys,
      descriptionKey = _ref.descriptionKey,
      withBenefits = _ref.withBenefits;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          dangerouslySetInnerHTML: {
            __html: t(titleKey)
          },
          withoutBottomPadding: (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && !!descriptionKey
        }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          dangerouslySetInnerHTML: {
            __html: t(descriptionKey)
          }
        }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: t(listKey)
              }
            })]
          }, key);
        }))]
      })]
    }), withBenefits && /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefits, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit1.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit2.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit3.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit4.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 58596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Lecturer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.elements.tsx



var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Wrapper",
  componentId: "sc-1urcrvf-0"
})(["display:inline-flex;align-items:center;margin-right:", ";margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Lecturerelements__ImageSection",
  componentId: "sc-1urcrvf-1"
})(["position:relative;width:", ";height:", ";overflow:hidden;border-radius:50%;margin-right:", ";margin-bottom:", ";@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(2), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(32));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Lecturerelements__Image",
  componentId: "sc-1urcrvf-2"
})(["position:absolute;left:50%;top:50%;width:100%;height:auto;transform:translate(-50%,-50%);"]);
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Title",
  componentId: "sc-1urcrvf-3"
})(["font-weight:", ";color:", ";"], function (prop) {
  return prop.isBold ? prop.theme.fontWeights.textBold : prop.theme.fontWeights.textRegular;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.tsx







var LecturerTemplate = function LecturerTemplate(_ref) {
  var image = _ref.image,
      isBold = _ref.isBold,
      name = _ref.name,
      slug = _ref.slug;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    onClick: function onClick() {
      return slug && router.push({
        pathname: "".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(slug)
      });
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: image
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: name
    })]
  });
};

/* harmony default export */ var Lecturer = (LecturerTemplate);

/***/ }),

/***/ 42420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Package; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/Package/Package.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageelements__Wrapper",
  componentId: "sc-1xcvnya-0"
})(["display:inline-flex;width:", ";height:", ";background:", ";align-items:center;justify-content:center;border-radius:", ";color:", ";font-weight:", ";font-size:", ";margin:0 ", " 0 ", ";"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(20), function (props) {
  return props.background;
}, (0,polished_esm/* rem */.hO)(24), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textRegular;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Package/Package.tsx





var PackageTemplate = function PackageTemplate(_ref) {
  var symbol = _ref.symbol,
      color = _ref.color;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    background: color,
    children: symbol
  });
};

/* harmony default export */ var Package = (PackageTemplate);

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatLecturerName; }
/* harmony export */ });
var formatLecturerName = function formatLecturerName(person) {
  if (!person) return;
  return "".concat(person.titles.before_name ? "".concat(person.titles.before_name, " ") : '').concat(person.name, " ").concat(person.surname).concat(person.titles.after_name ? ", ".concat(person.titles.after_name) : '');
};

/***/ }),

/***/ 13329:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rocne-predplatne",
      function () {
        return __webpack_require__(36797);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,6066,5675,4623,1384,9774,2888,179], function() { return __webpack_exec__(13329); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);